export default [
  {
    path: "/index-patients",
    name: "index-patients",
    component: () => import("@/views/clients/IndexPatients.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/index-patient/:id",
    name: "index-patient-profile",
    component: () => import("@/views/pages/profile/IndexPatientProfile.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/contacts",
    name: "contacts",
    component: () => import("@/views/clients/Contacts.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/contact/:id",
    name: "contact-profile",
    component: () => import("@/views/pages/profile/ContactProfile.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/risk-groups",
    name: "risk-groups",
    component: () => import("@/views/clients/RiskGroups.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/risk-group/:id",
    name: "risk-group-profile",
    component: () => import("@/views/pages/profile/RiskGroupProfile.vue"),
    meta: {
      authRequired: true,
    },
  },
]


